import { render, staticRenderFns } from "./ownerBindRoom.vue?vue&type=template&id=552e7818&scoped=true"
import script from "./ownerBindRoom.vue?vue&type=script&lang=js"
export * from "./ownerBindRoom.vue?vue&type=script&lang=js"
import style0 from "./ownerBindRoom.vue?vue&type=style&index=0&id=552e7818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e7818",
  null
  
)

export default component.exports